
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"76.5 163.313 459 459"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"465.375","cy":"552.188","r":"47.813","fill":"#FF22B1"}}),_c('path',{attrs:{"fill":"#1D1C39","d":"M408 163.313c-70.125 0-127.5 57.375-127.5 127.5v76.5H204c-70.125 0-127.5 57.375-127.5 127.5s57.375 127.5 127.5 127.5 127.5-57.375 127.5-127.5v-76.5H408c70.125 0 127.5-57.375 127.5-127.5s-57.375-127.5-127.5-127.5zm-127.5 331.5c0 42.075-34.425 76.5-76.5 76.5s-76.5-34.425-76.5-76.5 34.425-76.5 76.5-76.5h76.5v76.5zm127.5-127.5h-76.5v-76.5c0-42.075 34.425-76.5 76.5-76.5s76.5 34.425 76.5 76.5-34.425 76.5-76.5 76.5z"}}),_c('path',{attrs:{"fill":"#FF22B1","d":"M465.375 504.375c-26.138 0-47.813 21.675-47.813 47.813S439.237 600 465.375 600s47.813-21.675 47.813-47.813-21.038-47.812-47.813-47.812z"}})])
          )
        }
      }
    